export function formatPhoneNumber(str: string, fallback = ''): string {
  if (str) {
    const cleaned = (str.concat('')).replace(/\D/g, '')
    const match = cleaned.match(/^(\d{2})(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/)
    if (match) {
      return '+'.concat(match.slice(1).join(' '))
    }
    return '-'
  } else {
    return fallback
  }
}
